<template>
  <v-dialog v-model="dialog" max-width="70%" persistent scrollable>
      <v-card>
        <v-card-title class="py-3">
            <v-col cols="12" class="pa-0 text-right">
                <v-btn icon color="primary" @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" class="pa-0 text-center">
                <h1 class="py-0">Registros de Integração de recursos</h1>
            </v-col>
        </v-card-title>

            <v-card-text class="py-3">
                <!-- <v-tabs v-model="tab" @change="mudarAba" class="elevation-0 px-3">
                    <v-tab >Lotes Conciliados</v-tab>
                    <v-tab >Logs de integração</v-tab>

                    <v-tabs-items v-model="tab">
                        <v-tab-item>
                        <v-row class="py-3 px-1">
                            <v-col class="py-0 px-2" cols="12">
                                <v-data-table 
                                dense 
                                :headers="headersLotes" 
                                :items="listaLotes" 
                                :items-per-page="-1"
                                hide-default-footer
                                >
                                <template v-slot:item.arq_nome="{ item }">
                                    <template v-if="dadosPagamento.itg_sdi_rec">
                                        <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                            x-small
                                            class="mr-3 mt-1 mb-1"
                                            :color="estadoList[item.status_integracao_erp_rec].color"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="getLogs(dadosPagamento, item.id, 1), tab = 1, loteId = item.id"
                                            >fa fa-exchange-alt</v-icon>
                                        </template>
                                        <span
                                            class="px-2 py-1 ma-0"
                                            style="
                                            border: solid 1px #999;
                                            border-radius: 5px;
                                            background-color: #fff;
                                            "
                                            >{{estadoList[item.status_integracao_erp_rec].descricao}}</span>
                                        </v-tooltip>
                                    </template>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                        <span v-bind="attrs" v-on="on" class="pa-0">
                                            {{ item.arq_nome.substr(0,18) }}
                                        </span>
                                        </template>
                                        <span
                                        class="px-3 py-1 ma-0"
                                        style="
                                            border: solid 1px #999;
                                            border-radius: 5px;
                                            background-color: #fff;
                                        "
                                        >{{ item.arq_nome }}</span
                                        >
                                    </v-tooltip>
                                </template>
            <template v-slot:item.valor_informado="{ item }" class="px-1 py-0">
              <b>{{ item.valor_informado | formatPrice }}</b>
            </template>
            <template v-slot:item.valor_conciliado="{ item }">
              <b>{{ item.valor_conciliado | formatPrice }}</b> ({{
                item.perc_valor_conciliado
              }}
              %)
            </template>
            <template v-slot:item.valor_liberado="{ item }">
              <b style="color: green">{{
                item.valor_liberado | formatPrice
              }}</b>
              ({{ item.perc_valor_liberado }} %)
            </template>
            <template v-slot:item.valor_glosado="{ item }">
              <b style="color: red">{{ item.valor_glosado | formatPrice }}</b>
              ({{ item.perc_valor_glosado }} %)
            </template>
                                    </v-data-table>
                                </v-col>
                                <v-col class="pa-0" cols="12">
                                    <v-pagination
                                        class="no-box-shadow"
                                        v-model="currentPageLote"
                                        :length="lotesPagesTotal"
                                        @input="getLotes(dadosPagamento, currentPageLote)"
                                    ></v-pagination>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                        <v-tab-item> -->
                            <!-- <v-row class="pt-3 px-1">
                                <v-col class="py-0 px-2" cols="3">
                                    <label>Lote</label>
                                    <v-autocomplete
                                        v-model="loteId"
                                        :items="lotes"
                                        item-value="arquivo_id"
                                        item-text="num_lote"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                        flat
                                        solo
                                        dense
                                        outlined
                                    >
                                        <template v-slot:item="data">
                                        <template v-if="(typeof data.item !== 'object')">
                                            <v-list-item-content v-text="data.item"></v-list-item-content>
                                        </template>
                                        <template v-else>
                                            <v-list-item-content>
                                            <v-list-item-title v-html="data.item.num_lote"></v-list-item-title>
                                            </v-list-item-content>
                                            <v-list-item-avatar size="15" :color="data.item.color" v-if="data.item.color">
                                            </v-list-item-avatar>
                                        </template>
                                        </template>
                                    </v-autocomplete>
                                <v-autocomplete
                                    v-model="loteId"
                                    :items="lotes"
                                    item-value="arquivo_id"
                                    item-text="num_lote"
                                    :menu-props="{ bottom: true, offsetY: true }"
                                    flat
                                    solo
                                    dense
                                    outlined
                                ></v-autocomplete> 
                                </v-col>
                                <v-col class="pt-5 px-2" cols="3">
                                    <v-btn
                                    small 
                                    height="32px"
                                    color="primary"
                                    class="px-1 mr-3"
                                    depressed
                                    @click="getLogs(dadosPagamento, loteId, 1)"
                                    >Filtrar</v-btn>
                                    <v-btn
                                    outlined
                                    small 
                                    height="32px"
                                    color="primary"
                                    class="px-1 mr-3"
                                    depressed
                                    @click="loteId = null, getLogs(dadosPagamento, loteId, 1)"
                                    >Limpar Filtro</v-btn>
                                </v-col>
                            </v-row> -->
                            <v-row class="pb-3 px-1">
                                <v-col class="py-0 px-2" cols="12">
                                    <v-data-table
                                        dense
                                        :headers="headers"
                                        :items="listaLogs"
                                        :items-per-page="-1"
                                        hide-default-footer
                                    >
                                        <template v-slot:item="props">
                                            <tr>
                                                <td>
                                                    {{ props.item.data_processamento | formatDateHour }}
                                                </td>
                                                <!-- <td>
                                                    {{ props.item.num_lote }}
                                                </td> -->
                                                <td>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <span v-bind="attrs" v-on="on" class="pr-2">
                                                                <v-icon :color="colorList[props.item.status]" small>
                                                                    fa fa-exchange-alt
                                                                </v-icon>
                                                            </span>
                                                        </template>
                                                        <span class="px-3 py-1 ma-0" style=" border: solid 1px #999; border-radius: 5px; background-color: #fff;">
                                                            {{ labelList[props.item.status] }}
                                                        </span>
                                                    </v-tooltip>
                                                </td>
                                                <td>
                                                    <span v-if="props.item.erro === ''"> {{ labelList[props.item.status] }} </span>
                                                    <span v-else style="color: #d0021b"> {{ props.item.erro }} </span>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-col>
                                <v-col class="pa-0" cols="12">
                                    <v-pagination
                                        class="no-box-shadow"
                                        v-model="currentPageLog"
                                        :length="logsPagesTotal"
                                        @input="getLogs(dadosPagamento, loteId, currentPageLog)"
                                    ></v-pagination>
                                </v-col>
                            </v-row>
                        <!-- </v-tab-item>
                    </v-tabs-items>
                    </v-tabs> -->
            </v-card-text>
            <v-card-actions class="px-8">
                <v-btn outlined color="primary" height="30px" small depressed @click="close()">
                    Fechar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn  v-if="dadosPagamento && dadosPagamento.status_integracao_erp_rec < 0" color="primary" height="30px" small depressed @click="retry(dadosPagamento)"> 
                    Reenviar
                </v-btn>
            </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment"
export default {

    data() {
        return {
            headers: [
                { text: "Data de processamento", value: "data_processamento", sortable: false },
                //{ text: "Número do lote", value: "num_lote", sortable: false },
                { text: "Status", value: "status", sortable: false },
                { text: "Mensagem", value: "erro", sortable: false },
            ],
            // headersLotes: [
            //     {text: "Lotes conciliados", value: "arq_nome", class: "py-0", sortable: true},
            //     {text: "Nº lote", value: "arq_numero_lote", align: "left", class: "py-0", sortable: true},
            //     {text: "Ident. na operadora", value: "identificador_prestador", class: "py-0", sortable: true},
            //     {text: "Protocolo", value: "env_op_protocolo", class: "py-0", sortable: true },
            //     {text: "Nº nota fiscal", value: "arq_nfs", align: "left", class: "py-0", sortable: true},
            //     {text: "Valor apresentado", value: "valor_informado", align: "right", class: "py-0", sortable: true},
            //     {text: "Valor conciliado", value: "valor_conciliado", align: "right", class: "py-0", sortable: true},
            //     {text: "Pagamento", value: "valor_liberado", align: "right", class: "py-0", sortable: true},
            //     {text: "Glosa", value: "valor_glosado", align: "right", class: "py-0", sortable: true}
            // ],
            colorList:{
                "0": "primary",
                "1": "#B2B842",
                "2": "#9154CD",
                "3": "#32B88B",
                "-1": "#D0021B",
                "-2": "#FC9D0A",
                },
            labelList:{
                "0": "Não integrado",
                "1": "Em processamento",
                "2": "Aguardando baixa contábil",
                "3": "Integração finalizada",
                "-1": "Falha total na integração",
                "-2": "Falha parcial na integração",
            },
            loteId: null,
            currentPageLote: 1,
            currentPageLog: 1,
            pages: 1,
            tab: 0
        }
    },
    filters: {
        formatDateHour(date) {
            return moment(date).format('L') + ' às ' + moment(date).format('LT') + 'h'
        },
    },
    watch:{
        dialog(val){
            if(val){
                //this.tab = 0;
                this.loteId = null;
                this.getLogs(this.dadosPagamento, this.loteId, this.currentPageLog)
            }
        }
    },
    // methods: {
    //     mudarAba(){
    //         if(this.tab == 0){
    //             this.getLotes(this.dadosPagamento, this.currentPageLote)
    //         } else {
    //             this.LoteId = null;
    //             this.getLogs(this.dadosPagamento, this.loteId, this.currentPageLog)
    //         }
    //     },
    // },
    props: {
        close: Function,
        dadosPagamento: Object,
        dialog: Boolean,
        estadoList: Object,
        getLogs: Function,
        getLotes: Function,
        listaLogs: Array,
        listaLotes: Array,
        logsPagesTotal: Number,
        lotes: Array,
        lotesPagesTotal: Number,
        retry: Function,
    },
}
</script>

<style>
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr:last-child > th:first-child {
    max-width: 200px;
}
</style>
